// In src/components/PrayerRequestModal.js

import React, { useState } from 'react';
import {
  Modal, Box, Typography, TextField, Button,
  FormControlLabel, Checkbox, FormGroup, CircularProgress
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

// Now accepts a 'loading' prop
function PrayerRequestModal({ open, onClose, onSave, loading }) {
  const [text, setText] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);

  const handleSave = () => {
    if (!text) {
      alert('Please enter a prayer request.');
      return;
    }
    const prayerData = {
      text,
      isAnonymous,
      isPrivate,
    };
    onSave(prayerData);
  };

  // Clear form when the modal is closed
  const handleClose = () => {
    setText('');
    setIsAnonymous(false);
    setIsPrivate(false);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="prayer-request-modal-title"
    >
      <Box sx={style}>
        <Typography id="prayer-request-modal-title" variant="h6" component="h2">
          Submit a Prayer Request
        </Typography>
        <TextField
          margin="normal" fullWidth label="Your Prayer Request" multiline rows={6}
          value={text} onChange={(e) => setText(e.target.value)}
        />
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={isAnonymous} onChange={(e) => setIsAnonymous(e.target.checked)} />}
            label="Submit Anonymously"
          />
          <FormControlLabel
            control={<Checkbox checked={isPrivate} onChange={(e) => setIsPrivate(e.target.checked)} />}
            label="Make this private (visible to leadership only)"
          />
        </FormGroup>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleClose} sx={{ mr: 1 }}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Submit'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default PrayerRequestModal;
